export { default as MapLoadingIndicator } from './MapLoadingIndicator';
